import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, postApproval } from "./warehouseApi";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
};

export const fetchAll = createAsyncThunk(
  "warehouse/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const createApproval = createAsyncThunk(
  "warehouse/createApproval",
  async ({ retNumber, payload }) => {
    const response = await postApproval(retNumber, payload);
    return response;
  }
);

export const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = warehouseSlice.actions;

export const selectData = (state) => state.warehouse.data;
export const selectLoading = (state) => state.warehouse.loading;
export const selectError = (state) => state.warehouse.error;
export const selectPageNo = (state) => state.warehouse.pageNo;
export const selectPageSize = (state) => state.warehouse.pageSize;
export const selectTotalRecord = (state) => state.warehouse.totalRecord;
export const selectSelected = (state) => state.warehouse.selected;

export default warehouseSlice.reducer;
